import React, { useState } from "react";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";

import {
  WhatsappShareButton,
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton
} from "react-share";

import {
  WhatsappIcon,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  EmailIcon
} from "react-share";

const ApplyShareMenu = ({ url }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      {/* Normal (non-absolute) icon button */}
      <IconButton
        onClick={handleOpen}
        sx={{
          color: "#1976d2",           // Blue color
          backgroundColor: "#E3F2FD", // Light blue background
          width: 32,
          height: 32,
          borderRadius: "20%",
          "&:hover": {
            backgroundColor: "#BBDEFB",
          }
        }}
      >
        <ShareIcon fontSize="small" />
      </IconButton>

      {/* Popup Menu */}
            {/* Menu */}
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>

        {/* WhatsApp */}
        <MenuItem onClick={handleClose}>
           <a
            href={`https://wa.me/?text=${encodeURIComponent(url)}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "flex", textDecoration: "none", color: "inherit" }}
          >
            <ListItemIcon><WhatsappIcon size={32} round /></ListItemIcon>
            <ListItemText primary="WhatsApp" />
          </a>
        </MenuItem>

        {/* Facebook */}
        <MenuItem onClick={handleClose}>
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "flex", textDecoration: "none", color: "inherit" }}
          >
            <ListItemIcon><FacebookIcon size={32} round /></ListItemIcon>
            <ListItemText primary="Facebook" />
          </a>
        </MenuItem>

        {/* Twitter */}
        <MenuItem onClick={handleClose}>
          <a
            href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "flex", textDecoration: "none", color: "inherit" }}
          >
            <ListItemIcon><TwitterIcon size={32} round /></ListItemIcon>
            <ListItemText primary="Twitter" />
          </a>
        </MenuItem>

        {/* LinkedIn */}
        <MenuItem onClick={handleClose}>
          <a
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "flex", textDecoration: "none", color: "inherit" }}
          >
            <ListItemIcon><LinkedinIcon size={32} round /></ListItemIcon>
            <ListItemText primary="LinkedIn" />
          </a>
        </MenuItem>

        {/* Email */}
        <MenuItem onClick={handleClose}>
          <a
            href={`mailto:?subject=Check this profile&body=${encodeURIComponent(url)}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "flex", textDecoration: "none", color: "inherit" }}
          >
            <ListItemIcon><EmailIcon size={32} round /></ListItemIcon>
            <ListItemText primary="Email" />
          </a>
        </MenuItem>

      </Menu>
      {/* <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem>
          <WhatsappShareButton url={url} style={{ display: "flex" }}>
            <ListItemIcon><WhatsappIcon size={30} round /></ListItemIcon>
            <ListItemText primary="WhatsApp" />
          </WhatsappShareButton>
        </MenuItem>

        <MenuItem>
          <FacebookShareButton url={url} style={{ display: "flex" }}>
            <ListItemIcon><FacebookIcon size={30} round /></ListItemIcon>
            <ListItemText primary="Facebook" />
          </FacebookShareButton>
        </MenuItem>

        <MenuItem>
          <TwitterShareButton url={url} style={{ display: "flex" }}>
            <ListItemIcon><TwitterIcon size={30} round /></ListItemIcon>
            <ListItemText primary="Twitter" />
          </TwitterShareButton>
        </MenuItem>

        <MenuItem>
          <LinkedinShareButton url={url} style={{ display: "flex" }}>
            <ListItemIcon><LinkedinIcon size={30} round /></ListItemIcon>
            <ListItemText primary="LinkedIn" />
          </LinkedinShareButton>
        </MenuItem>

        <MenuItem>
          <EmailShareButton url={url} subject="Check this profile" body={url} style={{ display: "flex" }}>
            <ListItemIcon><EmailIcon size={30} round /></ListItemIcon>
            <ListItemText primary="Email" />
          </EmailShareButton>
        </MenuItem>
      </Menu> */}
    </>
  );
};

export default ApplyShareMenu;
